import { inject, Injectable } from "@angular/core";
import { GraphService } from "@app/kernel/graphql/services/graph.service";
import { GET_STOCK_NOTIFICATION_SETTINGS_QUERY } from "../query/stock-notification-settings.query";
import { IStockNotificationSettings } from "../interfaces/stock-notification-settings.interface";
import { map } from "rxjs";

@Injectable({ providedIn: "root" })
export class StockNotificationSettingsApiService {
  private graphql = inject(GraphService);

  getStockNotificationSettings() {
    return this.graphql
      .constructWatchQuery<{
        getStockNotificationSettings: IStockNotificationSettings;
      }>([GET_STOCK_NOTIFICATION_SETTINGS_QUERY], "getStockNotificationSettings")
      .pipe(
        map(res => {
          if (res.errors?.length) throw res.errors.length;
          return res.data.getStockNotificationSettings;
        })
      );
  }
}
